export const LOANTERM_LOADING = "LOANTERM_LOADING";
export const LOANTERM_RESET = "LOANTERM_RESET";
export const GET_LOANTERM = "GET_LOANTERM";
export const GET_LOANTERM_SUCCESS = "GET_LOANTERM_SUCCESS";
export const GET_LOANTERM_FAIL = "GET_LOANTERM_FAIL";
export const DELETE_LOANTERM = "DELETE_LOANTERM"
export const DELETE_LOANTERM_SUCCESS = "DELETE_LOANTERM_SUCCESS"
export const DELETE_LOANTERM_FAIL = "DELETE_LOANTERM_FAIL"
export const UPDATE_LOANTERM = "UPDATE_LOANTERM"
export const UPDATE_LOANTERM_SUCCESS = "UPDATE_LOANTERM_SUCCESS"
export const UPDATE_LOANTERM_FAIL = "UPDATE_LOANTERM_FAIL"
export const ADD_NEW_LOANTERM = "ADD_NEW_LOANTERM"
export const ADD_LOANTERM_SUCCESS = "ADD_LOANTERM_SUCCESS"
export const ADD_LOANTERM_FAIL = "ADD_LOANTERM_FAIL"